import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useRef, useContext } from 'react';
import InventoryContext from '~/contexts/InventoryContext';

function useTrackTilePerformance() {
  const { inventory } = useContext(InventoryContext);
  const loadStart = useRef(performance.now());

  useEffect(() => {
    if (inventory.isLoaded) {
      const loadEnd = performance.now();
      const loadTime = loadEnd - loadStart.current;
      datadogRum.addAction('tile-load-time', { loadTime });
    }

    // reset timing
    loadStart.current = performance.now();
  }, [inventory.isLoaded]);
}

export default useTrackTilePerformance;
